import * as React from "react";
import PhoneInput from "react-phone-input-2";
import Modal from "react-modal";
import styles from "./modal.scss";
import left from "../../../assets/homePoster/popup-left.png";
import cross from "../../../assets/icons/cross.png";

import logo from "../../../assets/form/Logo.png";

const NeedExpertPopup = (props) => {
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [projectScope, setProjectScope] = React.useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
    const homeForm = { name, email, phone, projectScope };
    console.log(homeForm);
  };
  const modalIsOpen = React.useState(props.isOpen);

  const closeModal = () => {
    props.closeModal();
  };

  React.useEffect(() => {
    // document.body.style.overflow = "hidden";
    // return () => (document.body.style.overflow = "unset");
  }, []);

  return (
    <Modal
      isOpen={false}
      onRequestClose={closeModal}
      contentLabel="Need Expert Popup"
      className="modal"
      overlayClassName="overlay"
    >
      <div className="bg-dark-indigo">
        <div className="flex gap-5 max-md:flex-col max-md:gap-0">
          <div className="flex flex-col w-[21%] max-md:ml-0 max-md:w-full">
            <img
              loading="lazy"
              src={left}
              className="grow shrink-0 max-w-full aspect-[0.29] fill-indigo-500 fill-opacity-10 w-[294px] max-md:mt-8"
            />
          </div>
          <div className="flex flex-col ml-5 max-md:ml-0 max-md:w-full">
            <div className="grow max-md:mt-8 max-md:max-w-full">
              <div className="flex gap-5 max-md:flex-col max-md:gap-0">
                <div className="flex flex-col max-md:ml-0 max-md:w-full">
                  <div className="flex z-10 flex-col px-5 mt-24 max-md:mt-10 max-md:max-w-full">
                    <div className="text-5xl font-medium leading-10 text-center text-white capitalize max-md:max-w-full">
                      Unlock extensive access to specialized market insights.
                    </div>
                    <div className="mt-16 mx-auto bg-white rounded-xl shadow-xl">
                      <form
                        className=" self-end pb-8 max-w-full bg-white rounded-xl shadow-xl max-md:w-full max-md:mt-10 max-md:ml-2.5 form"
                        onSubmit={(e) => handleSubmit(e)}
                      >
                        <div className="flex gap-2.5 px-4 py-2 text-xl font-semibold text-white whitespace-nowrap bg-light-indigo rounded-t-xl shadow-sm max-md:flex-wrap">
                          <img
                            alt="Expertefy Logo"
                            src={logo}
                            className="shrink-0 aspect-[1.03] w-[33px]"
                          />
                          <span className="flex-auto my-auto">EXPERTEFY</span>
                        </div>
                        <div className="flex flex-col px-5 max-md:max-w-full">
                          <h2 className="text-xl font-bold text-color leading-[48.09px]">
                            Got a Project in Mind?
                          </h2>
                          <label htmlFor="name" className="sr-only">
                            Your Name
                          </label>
                          <input
                            type="text"
                            id="name"
                            className="box-border flex relative flex-col shrink-0 p-2.5 rounded-md border-2 border-dark-indigo border-solid"
                            placeholder="Your Name"
                            aria-label="Your Name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                          />

                          <label htmlFor="email" className="sr-only">
                            Your Email
                          </label>
                          <input
                            type="email"
                            id="email"
                            className="box-border flex relative flex-col shrink-0 p-2.5 mt-5 rounded-md border-2 border-dark-indigo border-solid"
                            placeholder="Your Email"
                            aria-label="Your Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                          />

                          <PhoneInput
                            className="box-border flex relative flex-col shrink-0 p-1.5 mt-5 rounded-md border-2 border-dark-indigo border-solid"
                            inputStyle={{
                              borderStyle: "none",
                              width: "inherit",
                            }}
                            dropdownStyle={{
                              borderStyle: "solid",
                              border: 1,
                              borderColor: "#6369C4",
                              backgroundColor: "#fff",
                            }}
                            buttonStyle={{
                              borderStyle: "none",
                              border: 0,
                              backgroundColor: "#fff",
                            }}
                            required
                            country={"us"}
                            value={phone}
                            onChange={(ph) => setPhone(ph)}
                          />

                          <label htmlFor="projectScope" className="sr-only">
                            Let us know the project scope
                          </label>
                          <textarea
                            id="projectScope"
                            className="box-border flex relative flex-col shrink-0 px-2.5 pt-2.5 pb-4 my-5 rounded-md border-2 border-dark-indigo border-solid"
                            placeholder="Let us know the project scope"
                            aria-label="Project Scope"
                            value={projectScope}
                            onChange={(e) => setProjectScope(e.target.value)}
                            required
                          ></textarea>
                          <button className="justify-center dark-button items-center self-center px-16 py-5 mt-7 max-w-full text-2xl text-center text-white rounded-lg  shadow-xl w-[323px] max-md:px-5">
                            Submit Request
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col ml-5 w-[38%] max-md:ml-0 max-md:w-full">
                  <div className="flex overflow-hidden relative flex-col grow items-center px-16 pt-12 pb-20 fill-indigo-500 fill-opacity-10 min-h-[1024px] max-md:px-5 max-md:max-w-full">
                    <img
                      loading="lazy"
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/c1cebbf09fd00b22b840ef332ba3ab6d3d15aca1ea11ef303bd135014da33abb?"
                      className="object-cover absolute inset-0 size-full"
                    />
                    <div className="relative shrink-0 w-12 h-12 rounded-full border-2 border-white border-solid">
                      <img alt="" src={cross} onClick={closeModal()}></img>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default NeedExpertPopup;
